module.exports = __webpack_public_path__ + "img/icon-add-doctor.fec4b1b.svg";